export class MailDestinatairesDeleteInput {
  id: number;
  contactName: string;
}
